import React, { Component } from 'react';
import { Grid, Row, Col, ButtonToolbar, Button, FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap';
import { Stage, Layer, Group, Rect, Line, Text } from 'react-konva';

export class StopsListDataIdentifierCommonForm extends Component {
    renderHideStrategiesForm(form) {
        if (form.showOnlyInSpineStops) {
            return null;
        }

        return (
            <div>
                <ControlLabel className="margin-top-15">Estratégias para esconder paragens (caso necessário)</ControlLabel>
                <Checkbox checked={form.hideNonInSpineStops}
                    onChange={() => this.props.onChangeCheckboxValue("hideNonInSpineStops")}>
                    Esconder paragens não configuradas como presentes na espinha
                </Checkbox>
                <Checkbox checked={form.hidePreviousStops}
                    onChange={() => this.props.onChangeCheckboxValue("hidePreviousStops")}>
                    Esconder paragens anterior à paragem alvo
                </Checkbox>
                <Checkbox checked={form.shrinkText}
                    onChange={() => this.props.onChangeCheckboxValue("shrinkText")}>
                    Ajustar tamanho do texto no caso de não caber nas dimensões especificadas
                </Checkbox>

                <ControlLabel className="margin-top-15">Opções</ControlLabel>
                <Checkbox checked={form.hideZoneLimitStops}
                    onChange={() => this.props.onChangeCheckboxValue("hideZoneLimitStops")}>
                    Permitir esconder paragens limites de zona
                </Checkbox>
                <Checkbox checked={form.hideStopsWithMapPoint}
                    onChange={() => this.props.onChangeCheckboxValue("hideStopsWithMapPoint")}>
                    Permitir esconder paragens que pertençam a um ponto notável
                </Checkbox>
            </div>
        );
    }

    renderStopTextConfigurationsForm(form) {
        return (
            <div>
                <FormGroup>
                    <ControlLabel className="margin-top-15">Confiração da Apresentação do Nome da Paragem</ControlLabel>
                    <Checkbox checked={form.showStopCode}
                        onChange={() => this.props.onChangeCheckboxValue("showStopCode")}>
                        Mostrar Código da Paragem
                    </Checkbox>
                </FormGroup>

                {this.renderStopCodePrecedentAndSubsequentTextForm(form)}
            </div>
        );
    }

    renderStopCodePrecedentAndSubsequentTextForm(form) {
        if (!form.showStopCode) {
            return null;
        }

        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Texto Precedente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodePrecendentText}
                    onChange={(e) => this.props.onChangeValue(e, "stopCodePrecendentText")} />

                <ControlLabel className="margin-top-15">Texto Subsequente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodeSubsequentText}
                    onChange={(e) => this.props.onChangeValue(e, "stopCodeSubsequentText")} />
            </FormGroup>
        );
    }

    renderBarsLayouts(barBuilderComponent, target, innerText) {
        return (
            <Grid fluid>
                <Row>
                    <Col md={4} sm={6} xs={12}>
                        <Stage width={260}
                            height={60}
                            style={{ cursor: "pointer" }}>
                            <Layer>
                                <Group onClick={() => this.props.onChangeSelectValue(0, target)}>
                                    <Rect x={5}
                                        y={5}
                                        width={250}
                                        height={50}
                                        strokeWidth={undefined === barBuilderComponent || 0 === barBuilderComponent ? 3 : 1}
                                        stroke={undefined === barBuilderComponent || 0 === barBuilderComponent ? "#6699ff" : "#4d4d4d"}
                                        fill="#FFFFFF" />

                                    <Rect x={15}
                                        y={20}
                                        width={115}
                                        height={20}
                                        strokeWidth={1}
                                        stroke={"black"}
                                        fill="#FFFFFF" />
                                    <Rect x={130}
                                        y={20}
                                        width={115}
                                        height={20}
                                        strokeWidth={1}
                                        stroke={"black"}
                                        fill="#FFFFFF" />

                                    <Text text= {innerText['first']}
                                        fontSize={14}
                                        x={55}
                                        y={25} />
                                    <Text text={innerText['second']}
                                        fontSize={14}
                                        x={170}
                                        y={25} />
                                </Group>
                            </Layer>
                        </Stage>
                    </Col>

                    <Col md={4} sm={6} xs={12}>
                        <Stage width={260}
                            height={60}
                            style={{ cursor: "pointer" }}>
                            <Layer>
                                <Group onClick={() => this.props.onChangeSelectValue(1, target)}>
                                    <Rect x={5}
                                        y={5}
                                        width={250}
                                        height={50}
                                        strokeWidth={1 === barBuilderComponent ? 3 : 1}
                                        stroke={1 === barBuilderComponent ? "#6699ff" : "#4d4d4d"}
                                        fill="#FFFFFF" />

                                    <Line
                                        x={15}
                                        y={20}
                                        points={[0, 0, 0, 20]}
                                        stroke="black"
                                        strokeWidth={1} />
                                    <Line
                                        x={15}
                                        y={40}
                                        points={[0, 0, 113, 0]}
                                        stroke="black"
                                        strokeWidth={1} />

                                    <Line
                                        x={132}
                                        y={20}
                                        points={[0, 0, 0, 20]}
                                        stroke="black"
                                        strokeWidth={1} />
                                    <Line
                                        x={132}
                                        y={40}
                                        points={[0, 0, 113, 0]}
                                        stroke="black"
                                        strokeWidth={1} />

                                    <Text text={innerText['first']}
                                        fontSize={14}
                                        x={55}
                                        y={25} />
                                    <Text text={innerText['second']}
                                        fontSize={14}
                                        x={170}
                                        y={25} />
                                </Group>
                            </Layer>
                        </Stage>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderDurationBarConfigurationsForm(form) {
        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Barra da Duração</ControlLabel>
                {this.renderBarsLayouts(
                    form.durationBackgroundBuilderComponent, 
                    "durationBackgroundBuilderComponent", 
                    {'first':'10min', 'second':'15min'}
                )}
            </FormGroup>
        );
    }

    renderZonesBarConfigurationsForm(form) {
        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Barra da Zona</ControlLabel>
                {this.renderBarsLayouts(
                    form.zonesBackgroundBuilderComponent, 
                    "zonesBackgroundBuilderComponent", 
                    {'first':'Zona A', 'second':'Zona B'}
                )}
            </FormGroup>
        );
    }

    render() {
        const { form } = this.props;

        return (
            <div>
                <FormGroup
                    bsSize="small"
                    controlId="formDataHideStopStrategies" >
                    <ControlLabel>Estratégias para mostrar paragens</ControlLabel>
                    <Checkbox checked={form.showOnlyInSpineStops}
                        onChange={() => this.props.onChangeCheckboxValue("showOnlyInSpineStops")}>
                        Apenas paragens configuradas como presentes na espinha
                        </Checkbox>

                    {this.renderHideStrategiesForm(form)}
                </ FormGroup>

                {this.renderStopTextConfigurationsForm(form)}

                {this.renderDurationBarConfigurationsForm(form)}

                {this.renderZonesBarConfigurationsForm(form)}

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={this.props.onSelectData}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={this.props.onCancel}>CANCELAR</Button>
                </ButtonToolbar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/StopsListDataIdentifierCommonForm.js